import axios from "axios"

export default {
	state: {
		documents: []
	},

	actions: {
		getDocuments(actionContext, path) {
			return new Promise((resolve, reject) => {
				try {
					actionContext.commit("Loading/show", null, { root: true })

					actionContext.rootGetters["MopaneApi/getInstance"].get(`Service/GetDocsS3?path=${path}`)
						.then(response => {
							actionContext.commit("setDocuments", response.data)
							actionContext.commit("Loading/hide", null, { root: true })

							resolve()
						})
						.catch(response => {
							actionContext.dispatch("MopaneApi/processErrorResponse", response, { root: true })
							actionContext.commit("Loading/hide", null, { root: true })

							reject(response)
						})
				}
				catch (exception) {
					actionContext.dispatch("MopaneApi/processErrorResponse", exception, { root: true })
					actionContext.commit("Loading/hide", null, { root: true })

					reject(exception)
				}
			})
		},
		uploadFiles(actionContext, files) {
			return new Promise((resolve, reject) => {
				try {
					actionContext.commit("Loading/show", null, { root: true })

					files.forEach(function (file, i) {
						var pathParts = file.key.split("/")

						actionContext.rootGetters["MopaneApi/getInstance"].get(`Service/CreateS3Folder?tableName=${pathParts[0]}&recordId=${pathParts[1]}&path=${file.key.replace(`${pathParts[0]}/`, "").replace(pathParts[1], "")}`)
							.then(function () {
								var fileName = file.file.name
								var fileWithPath = `${file.key}/${fileName}`
								var fileWithPathEncoded = encodeURIComponent(fileWithPath)

								actionContext.rootGetters["MopaneApi/getInstance"].get(`Service/GetS3PolicyData?fileId=${fileWithPathEncoded}&redirectUrl=${window.location.origin}`)
									.then(function (response) {
										var formData = new FormData()
										formData.append('key', fileWithPath)
										formData.append('AWSAccessKeyId', response.data.akey)
										formData.append('acl', 'private')
										formData.append('policy', response.data.policy)
										formData.append('signature', response.data.signature)
										formData.append('redirect', window.location.origin)
										formData.append('file', file.file)

										axios({
											method: 'POST',
											url: response.data.action,
											data: formData
										})
											.then((response) => {
												resolve()
											})
											.catch(function (exception) {
												if (exception.message == 'Network Error') {
													resolve()

													return
												}

												actionContext.dispatch("MopaneApi/processErrorResponse", exception, { root: true })
												actionContext.commit("Loading/hide", null, { root: true })

												reject(exception)
											});

									})
									.catch(exception => {
										actionContext.dispatch("MopaneApi/processErrorResponse", exception, { root: true })
										actionContext.commit("Loading/hide", null, { root: true })

										reject(exception)
									})
							})
							.catch(exception => {
								actionContext.dispatch("MopaneApi/processErrorResponse", exception, { root: true })
								actionContext.commit("Loading/hide", null, { root: true })

								reject(exception)
							})
					})
				}
				catch (exception) {
					actionContext.dispatch("MopaneApi/processErrorResponse", exception, { root: true })
					actionContext.commit("Loading/hide", null, { root: true })

					reject(exception)
				}
			})
		},
		deleteFolder(actionContext, key) {
			return new Promise((resolve, reject) => {
				try {
					actionContext.commit("Loading/show", null, { root: true })

					actionContext.rootGetters["MopaneApi/getInstance"].get(`Service/DeleteS3Folder?key=${key}`)
						.then(function () {
							actionContext.commit("Loading/hide", null, { root: true })

							resolve()
						})
						.catch(exception => {
							actionContext.dispatch("MopaneApi/processErrorResponse", exception, { root: true })
							actionContext.commit("Loading/hide", null, { root: true })

							reject(exception)
						})
				}
				catch (exception) {
					actionContext.dispatch("MopaneApi/processErrorResponse", exception, { root: true })
					actionContext.commit("Loading/hide", null, { root: true })

					reject(exception)
				}
			})
		},
		deleteFiles(actionContext, keys) {
			return new Promise((resolve, reject) => {
				try {
					actionContext.commit("Loading/show", null, { root: true })
					
					for (var i = 0; i < keys.length; i++) {
						var key = keys[i]
						var pathParts = key.split("/")

						actionContext.rootGetters["MopaneApi/getInstance"].get(`Service/DeleteS3File?tableName=${pathParts[0]}&recordId=${pathParts[1]}&file=${pathParts[pathParts.length - 1]}`)
							.then(function () {
								actionContext.commit("Loading/hide", null, { root: true })

								resolve()
							})
							.catch(exception => {
								actionContext.dispatch("MopaneApi/processErrorResponse", exception, { root: true })
								actionContext.commit("Loading/hide", null, { root: true })

								reject(exception)
							})
					}
				}
				catch (exception) {
					actionContext.dispatch("MopaneApi/processErrorResponse", exception, { root: true })
					actionContext.commit("Loading/hide", null, { root: true })

					reject(exception)
				}
			})
		}
	},

	mutations: {
		setDocuments(state, documents) {
			state.documents = documents
		}
	},

	namespaced: true
}